import { render, staticRenderFns } from "./SendToEmailButton.vue?vue&type=template&id=0287e608&scoped=true&"
import script from "./SendToEmailButton.vue?vue&type=script&lang=js&"
export * from "./SendToEmailButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0287e608",
  null
  
)

export default component.exports